import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivationStatusIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0002 11.0648C13.2052 11.0648 14.182 10.088 14.182 8.88299C14.182 7.67801 13.2052 6.70117 12.0002 6.70117C10.7952 6.70117 9.81836 7.67801 9.81836 8.88299C9.81836 10.088 10.7952 11.0648 12.0002 11.0648Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9286 21.2012L14.2857 17.7921H16V16.5194C16 15.5067 15.5786 14.5355 14.8284 13.8195C14.0783 13.1034 13.0609 12.7012 12 12.7012C10.9391 12.7012 9.92172 13.1034 9.17157 13.8195C8.42143 14.5355 8 15.5067 8 16.5194V17.7921H9.71429L10.0714 21.2012",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.80077 2.93197C5.05759 3.94282 1.5 8.15659 1.5 13.2013C1.5 19.0003 6.20101 23.7013 12 23.7013C17.799 23.7013 22.5 19.0003 22.5 13.2013C22.5 7.91158 18.5884 3.53546 13.5 2.80762",
			stroke: "#001489",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25118 6.67084L10.5587 2.80749L6.69531 0.5",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgActivationStatusIcon);
export default ForwardRef;
